import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-htc-ltc-auth-form',
  templateUrl: './htc-ltc-auth-form.component.html',
  styleUrls: ['./htc-ltc-auth-form.component.css']
})
export class HtcLtcAuthFormComponent implements OnInit {

  title="HTC/LTC Authorization";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/htc-ltc-authorization/htc-ltc-auth-form/htc-ltc-auth-form.component.ts